"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaugeComponent = void 0;
var GaugeComponent_1 = __importDefault(require("./GaugeComponent"));
exports.GaugeComponent = GaugeComponent_1.default;
exports.default = GaugeComponent_1.default;
